'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WixStylesBoolUtils = {
    getFullBoolStyles: function getFullBoolStyles(_ref) {
        var _ref$boolStyles = _ref.boolStyles,
            boolStyles = _ref$boolStyles === undefined ? {} : _ref$boolStyles,
            compId = _ref.compId;

        var ret = {};

        function set(id, _default) {
            if (_lodash2.default.isUndefined(boolStyles[id])) {
                ret[id] = _default;
            } else {
                ret[id] = boolStyles[id];
            }
        }

        set('wixmenu.widgets.shortcut', false);
        set('wixmenu.widgets.specials', false);
        set('wixmenu.widgets.openinghours', false);
        set('wixmenu.widgets.phone', false);
        set('wixmenu.widgets.address', false);
        set('wixmenu.widgets.description', true);
        // set('wixmenu.widgets.price', true);
        // set('wixmenu.widgets.variations', true);
        set('wixmenu.widgets.icons', true);
        set('wixmenu.widgets.placeholderimages', true);
        set('wixmenu.widgets.sectionimages', true);
        set('wixmenu.widgets.imagesstyle', true);
        set('wixorders.widgets.sectionimages', true);
        set('wixorders.widgets.chainmap', true);
        set('wixorders.widgets.displaydishicons', true);
        set('wixorders.widgets.displayfontsexperiment', false);
        set('wixorders.widgets.displaycustomiconpreview', false);
        // social bar booleans
        set('wixsocialbar.show.facebook', true);
        set('wixsocialbar.show.twitter', true);
        set('wixsocialbar.show.instagram', true);
        set('wixsocialbar.show.yelp', true);
        set('wixsocialbar.show.tripadvisor', true);
        set('wixsocialbar.show.foursquare', true);
        set('wixsocialbar.custom.theme.selected', false);
        // seating booleans
        set('wixseating.title.display', true);
        set('wixseating.description.display', false);
        set('wixseating.has.custom', false);

        set(compId + '.wixmenu.widgets.showallmenus', null);
        set(compId + '.wixmenu.widgets.price', true);
        set(compId + '.wixmenu.widgets.variations', true);
        set(compId + '.wixmenu.widgets.displaySectionImages', null);
        set(compId + '.wixmenu.widgets.displaydishicons', true);
        set(compId + '.wixmenu.widgets.displaycustomiconpreview', false);

        return ret;
    }
};

exports.default = WixStylesBoolUtils;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/WixStylesBoolUtils.js
// module id = 296
// module chunks = 0